
<template>
<div id="app" >
  <!-- <v-app style="background: #003333;"> -->
    <div class="breadcrumbs" id="breadcrumbs">
        <button class="breadcrumb-home breadcrumb-btn" style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.3);" @click="$store.state.showTimeline = true; $store.state.showPrimarySource = false" aria-label="Go to main timeline">
            <img v-bind:src="require(`@/assets/ui/icon_breadcrumb_home.png`)" id="home-icon">
            <p>Timeline Home</p>
        </button>
        <button class="breadcrumb-current breadcrumb-btn">
            <p style="color: black"><span>Primary Source</span></p>
        </button>
    </div>
    <div class="btns">
        <p id="source-title" style="text-align: center" v-html="source"></p>
    </div>
    <div class="document-container">
        <div id="block" v-show="!displayOverlay"></div>
        <div class="scroll-content custom-scrollbar" id="style-1">
        <div v-if="primaryIsVideo()" style="text-align: center; margin-top: 3%;">
            <div v-html="link"></div>
        </div>
        <div v-if="!primaryIsVideo()" class="image-container">
            <img id="source-img" v-bind:src="require(`@/assets/art/primary-source-photos/${ getFileName() }.jpg`)" v-bind:alt="`${source}`">
            <form style="text-align: center;" target="_blank">
              <button class="outlined-button" v-bind:formaction="link">View Original Source</button>
            </form>
        </div>

        <div id="overlay-rect"></div>
        <div id="overlay">
            <div id="text"></div>
        </div>
        </div>
        <div style="text-align: center;">
            <button id="source-button" v-if="isDocument()" @click="toggleRead()"> {{ buttonLabel }} </button>
        </div>
    </div>   
  <!-- </v-app> -->
</div>
</template>

<script>
    import psData from '@/content/primarySources.js'
    export default {
    name: 'PrimarySource',

    props: ['source', 'link', 'id'],

    created () {
        window.addEventListener('resize', this.positionElements);
    },

    methods: {
        getFileName(){
            let file = this.json.find(item => item.id === this.id);
            if(typeof file !== 'undefined') return file.image;
            else return 'placeholder';
        },
        isDocument() {
            let file = this.json.find(item => item.id === this.id);
            if(typeof file !== 'undefined')
            {
                if(typeof file.text !== 'undefined') return true;
                else return false;
            }
            else {
                return false;
            }
            
        },
        primaryIsVideo() {
            var firstSeven = this.link.slice(0,7);
            return firstSeven == "<iframe";
        },
        toggleRead() {
            if(!this.displayOverlay) {
                document.getElementById("overlay").style.display = "none";
                document.getElementById("source-button").innerText = 'Read';
            }
            else {
                document.getElementById("overlay").style.display = "block";
                document.getElementById("source-button").innerText = 'Back';
            }
            this.displayOverlay = !this.displayOverlay;
            this.positionElements();
        },
        addLineSpacing(str){
            return str.replaceAll(('\n'), ('<br><br>'));
        },
        positionElements(){
            if(this.primaryIsVideo()) return;

            var img = document.getElementById('source-img');
            var breadcrumbs = document.getElementById('breadcrumbs');
            var title = document.getElementById('source-title'); 
            var block = document.getElementById("block");
            var overlay = document.getElementById("overlay");
            var overlayRect = document.getElementById("overlay-rect");
            var text = document.getElementById("text");

            // var screenWidth = document.documentElement.clientWidth;
            // var screenHeight = document.documentElement.clientHeight;
            var left = img.offsetLeft;
            var width = img.clientWidth;
            var bcHeight = breadcrumbs.clientHeight + title.clientHeight;
            var blockTop = bcHeight + overlayRect.clientHeight;
            // var btnHeight = blockTop;

            overlay.style.top = bcHeight + "px";
            block.style.top = blockTop + "px";
            text.style.width = width + "px";
            overlay.style.left = left + "px";

            if(this.isDocument())
            {
                var readBtn = document.getElementById('source-button'); 
                readBtn.style.top = blockTop + "px";
            }
        },
        getText() {
            this.sourceData = this.json.find(item => item.id === this.id);
            this.sourceText = this.addLineSpacing(this.sourceData.text);
            document.getElementById('text').innerHTML="<p>" + this.sourceText + "</p>";
        }
    },

    mounted: function () {
        window.scrollTo(0,0);
        if(this.isDocument()) this.getText();
        this.positionElements();
    },  

    data() {
        return {
            json: psData.sources,
            sourceData: {},
            sourceText: '',
            buttonLabel: 'Read',
            displayOverlay: true,
            sourceWidth: 0,
        }
    }
}
</script>

<style lang="css">
</style>